(function ($) {
  var videoCarouselV1 = {
    init: function (context, settings) {
    // YouTube
      var autoplayString = '&autoplay=1';
      var isMobile = $('body').hasClass('device-mobile');

      $('.video-carousel-v1').once('video-carousel-v1-template').find('.video').each(function () {
        var thisFormatter = $(this);

        // desktop
        if (!isMobile) {
        // setup active area
          var promos = thisFormatter.find('.active-video').find('.video-carousel-internet-video-v1');

          promos.each(function (i) {
            $(this).attr('item', 'item-' + i);
          });

          // setup sidebar
          var visibleItems = 3;
          var items = thisFormatter.find('.slides').find('.video-carousel-internet-video-v1');

          items.each(function (i) {
            $(this).attr('item', 'item-' + i);
          });

          // show carousel if more items
          if (items.length > visibleItems) {
            for (var i = 0; i < items.length; i += visibleItems) {
              items.slice(i, i + visibleItems).wrapAll('<li></li>');
            }

            var flexsliderID = '#' + thisFormatter.find('.flexslider').attr('id');
            var flexslider = $(flexsliderID);
            // build flexslider
            var flexsliderDir = flexslider.data('direction');
            var rtl = flexsliderDir && flexsliderDir == 'rtl' ? true : false;

            flexslider.flexslider({
              animation: 'slide',
              animationLoop: true,
              direction: 'vertical',
              slideshow: false,
              rtl: rtl
            }).addClass('flexslider-active');
          }

          // hover state
          thisFormatter.find('.flexslider-nav .video-thumb').hover(function () {
            $(this).addClass('hover');
          }, function () {
            $(this).removeClass('hover');
          });

          // backup original iframe src
          thisFormatter.find('.active-video').find('.video-carousel-internet-video-v1 iframe').each(function () {
            var src = $(this).attr('data-src');

            $(this).attr('original-src', src);
          });

          // remove extras video embeds
          thisFormatter.find('.flexslider-nav').find('.video-carousel-internet-video-v1 .video-main').each(function () {
            $(this).remove();
          });
          thisFormatter.find('.active-video').find('.video-carousel-internet-video-v1 .video-meta').each(function () {
            $(this).remove();
          });

          // active state
          thisFormatter.find('.flexslider-nav .video-thumb').first().addClass('active');
          thisFormatter.find('.flexslider-nav .video-thumb img').on('click', function() {
          // thumbs
            thisFormatter.find('.flexslider-nav .video-thumb').removeClass('active');
            $(this).parents('.video-thumb').addClass('active');

            // stop previous video
            var prevItem = thisFormatter.find('.active-video').find('.video-carousel-internet-video-v1:visible').attr('item');
            var prevIframe = thisFormatter.find('.active-video').find('.video-carousel-internet-video-v1[item=' + prevItem + '] iframe');
            var prevIframeSrc = prevIframe.attr('original-src');

            prevIframe.attr('src', '');
            prevIframe.attr('src', prevIframeSrc);

            // autoplay next video
            var item = $(this).parents('.video-carousel-internet-video-v1').attr('item');
            var iframe = thisFormatter.find('.active-video').find('.video-carousel-internet-video-v1[item=' + item + '] iframe');
            var iframeSrc = iframe.attr('original-src');
            var autoplaySrc = iframeSrc + autoplayString;

            iframe.attr('src', autoplaySrc);

            var $activeVid = thisFormatter.find('.active-video');

            $activeVid.find('.video-carousel-internet-video-v1').hide();
            $activeVid.find('.video-carousel-internet-video-v1[item=' + item + ']').show();
          });

          // apply custom color to active thumbs
          var color = thisFormatter.siblings('h3').css('color');

          if (color && color.length > 0) {
            $('<style type="text/css">.video-carousel-v1 .flexslider-nav .video-thumb.active .clip-thumb { border-color: ' + color + ' !important; </style>').appendTo('head');
          }

          // If there is only one available video hid thumbnail - DoneDone #274 - Video Template Modification
          var activeVideo = thisFormatter.find('.active-video');
          var videoThumb = thisFormatter.find('.flexslider-nav .video-thumb');

          if (videoThumb.length === 1) {
            videoThumb.addClass('hidden');
            activeVideo.addClass('only-child');
          }
        } else {
        // isMobile
          thisFormatter.find('.active-video').remove();
          thisFormatter.find('.video-carousel-internet-video-v1').each(function () {
            var flexVideo = $(this).find('.flex-video');
            var iframe = flexVideo.find('iframe');
            var iframeSrc = iframe.attr('data-src') || iframe.attr('src');

            if (!!iframeSrc) {
              var modestSrc = iframeSrc + '&modestbranding=1&showinfo=0';
              var thumb = $(this).find('.video-thumb');

              iframe.attr('src', modestSrc);
              flexVideo.prependTo(thumb);
            }
          });
        }
      });
    }
  };

  $(window).on('load', function() {
    videoCarouselV1.init();
  });
})(jQuery);
